import { SUPPORTED_LANGUAGES } from '../../const';
import { authService, translationService } from '../../services';
import { Routes } from '../routes';

/*
 * It the route is a locale code redirect to Home
 * And load translation if the locale code is in the URL
 */
const localeHandlingMiddleware = async ( action, nextRoute, _prevRoute ) => { 

    let regexMatch;
    const regex = /(\S+)?\/([a-zA-Z]{2}-[a-zA-Z]{2})\/?$/gmi;
    
    if ( ( regexMatch = regex.exec( nextRoute.pathname ) ) !== null ) {
        const locale = regexMatch[ regexMatch.length - 1 ];
        const path = regexMatch[ regexMatch.length - 2 ] || '/';

        const validLocale = SUPPORTED_LANGUAGES.find( i => 
            i.code.localeCompare( locale, undefined, { sensitivity: 'base' } ) === 0
        );
        
        // If there is a valid locale and user is not logged in load the translation
        if ( validLocale && !authService.isAuthenticated() ) { 
            translationService.fetchTranslations( { attemptExternal: false } );
        }

        // If at root url we redirect to portal
        if ( validLocale &&  path === '/' ) {
            action.redirect( Routes.Portal.buildPath( locale ) );
        } else {
            action.ok();
        } 
    } else {
        action.ok();
    }
};

export default localeHandlingMiddleware;
